import { Link } from "react-router-dom";
import '../../styles/ServiceStyles/MainService.css';
import { licences, quoteLink } from "../../data/licences";

const MainService = () => {
    return (
        <section className="km-section km-section--alt mainServiceContainer" id="licences">
            <div className="km-container">
                <div className="km-sectionHead km-sectionHead--center" data-reveal>
                    <p className="km-eyebrow">Licence types</p>
                    <h2 className="km-title">Which licence do you need?</h2>
                    <p className="km-lead">Compare the three SAHPRA licences. Not sure which applies to you? Request a quote and we will advise.</p>
                </div>
                <div className="km-cardRow">
                    {licences.map((licence, index) => (
                        <article
                            className="km-card license-card"
                            key={licence.id}
                            data-reveal
                            style={{ "--reveal-order": index } as React.CSSProperties}
                        >
                            <img src={licence.img} alt={licence.imgAlt} />
                            <h3>{licence.title}</h3>
                            <p className="service-audience">{licence.audience}</p>
                            <ul>
                                {licence.points.map((point) => <li key={point}>{point}</li>)}
                            </ul>
                            <Link className="km-btn km-btn--primary km-btn--block" to={quoteLink(licence.id)}>
                                Request a Quote <span className="km-arrow" aria-hidden="true">→</span>
                            </Link>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default MainService;
